import React, { useState } from 'react';

import * as S from './textArea.styles';
import { TextAreaProps } from './textArea.types';

export const TextArea: React.FC<TextAreaProps & React.HTMLProps<HTMLTextAreaElement>> = ({
  isDisabled = false,
  defaultValue = '',
  maxLength,
  placeHolderMessage,
  rowCount = 1,
  showCharCount = false,
  onChange,
  ...restProps
}) => {
  const [value, setValue] = useState(defaultValue);

  const handleChange = (event) => {
    const newValue = event.target.value;
    setValue(newValue);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <S.Wrapper>
      <S.TextArea
        $rowCount={rowCount}
        disabled={!!isDisabled}
        maxLength={maxLength}
        name="message"
        value={value}
        placeholder={placeHolderMessage}
        onChange={handleChange}
        {...restProps}
      />
      {showCharCount ? (
        <S.CharCount>{`${value.length}${maxLength ? '/' + maxLength : ''}`}</S.CharCount>
      ) : null}
    </S.Wrapper>
  );
};
